import actionTypes from "./actionTypes";
export default {
    setAvatarData: (data) => ({
        type: actionTypes.SET_AVATAR_DATA,
        data
    }),
    removeAvatarData: (ids) => ({
        type: actionTypes.REMOVE_AVATAR_DATA,
        ids
    })
};
